import { Button } from "@/shared/components/ui/button";
import { FilterIcon } from "@/shared/icons/FilterIcon";
import { useTranslation } from "react-i18next";
import {
  ActiveFilter,
  ActiveFilterPills,
} from "@/shared/components/common/ActiveFilterPills";
import {
  FilterSectionConfig,
  ListFilterPopover,
  ListFilterValues,
} from "@/shared/components/common/ListFilterPopover";

interface EntityListFilterProps {
  sections: FilterSectionConfig[];
  values: ListFilterValues;
  onChange: (values: ListFilterValues) => void;
  onApply: () => void;
  onLocalValuesChange?: (values: ListFilterValues) => void;
  onSectionChange?: (
    key: string,
    value: string | string[],
    current: ListFilterValues,
  ) => ListFilterValues;
  activeFilters: ActiveFilter[];
  onRemoveFilter: (id: string) => void;
  onClearAllFilters: () => void;
  showPills?: boolean;
}

export function EntityListFilter({
  sections,
  values,
  onChange,
  onApply,
  onLocalValuesChange,
  onSectionChange,
  activeFilters,
  onRemoveFilter,
  onClearAllFilters,
  showPills = true,
}: EntityListFilterProps) {
  const { t } = useTranslation("common");
  return (
    <div className="flex flex-col gap-5">
      <div className="flex flex-wrap items-center gap-2">
        <ListFilterPopover
          sections={sections}
          values={values}
          onChange={onChange}
          onApply={onApply}
          onLocalValuesChange={onLocalValuesChange}
          onSectionChange={onSectionChange}
          trigger={
            <Button
              type="button"
              variant="outline"
              size="sm"
              className="bg-white px-4 border-[#E5E7EB] rounded-lg h-9 text-[#374151]"
            >
              <FilterIcon className="h-4 w-4" />
              {t("actions.filter")}
            </Button>
          }
        />
      </div>
      {showPills ? (
        <ActiveFilterPills
          filters={activeFilters}
          onRemove={onRemoveFilter}
          onClearAll={onClearAllFilters}
        />
      ) : null}
    </div>
  );
}
